import Header from "../../header/Header";
import AccountInfo from "../account_info/AccountInfo";
import Footer from "../../footer/Footer";

function AccountLanding(){
    return(
        <div className="account_landing">
            <Header />
            <AccountInfo />
            <Footer />
        </div>
    )
}

export default AccountLanding